module.exports = __webpack_public_path__ + "static/media/3rd-party-interface-setup.7e09e4e3.svg";